import {SpinnerPanel} from './spinner-panel'

export function StartingAppIndicator(): JSX.Element {
    return <SpinnerPanel title="Initialising" />
}
